module.exports = __webpack_public_path__ + "img/Hawaiian_Poke_Wrap_Chicken.d5b15103.jpg";